<template>
  <div
    v-if="errors && errors.length"
    class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-lg mb-4"
  >
    <h2>
      {{ errors.length }} error(s) prohibited this {{ subject }} from being
      saved:
    </h2>
    <ul class="list-disc list-inside">
      <li v-for="error in errors" :key="error">{{ error }}</li>
    </ul>
  </div>
</template>

<script setup>
defineProps({
  errors: { type: Array, default: () => [] },
  subject: { type: String, default: "record" },
});
</script>
